// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1VrQO","header":"ReportDetails_header__2D037","title":"ReportDetails_title__694e_","left":"ReportDetails_left__13TiN"};